import React from 'react';

export const death = [
  { name: 'anexoCertidaoDeObito', label: 'Certidão de óbito*' },
];

export const deathOpcional = [
  { name: 'anexoCertidaoDeObito', label: 'Certidão de óbito' },
];

export const commons = [
  { name: 'anexoRG', label: 'RG*' },
  { name: 'anexoCPF', label: 'CPF*' },
];

export const others = [{ name: 'anexoOutros', label: 'Outros' }];

export const termos = [
  {
    name: 'anexoTermos',
    label: 'Termo de Opcao Percentual de Pagamento RCM em Valor Variável',
  },
];

export const termoTutelaJudicial = [
  {
    name: 'anexoTermoTutelaJudicial',
    label: 'Termo de tutela judicial*',
  },
];

export const seriousIllness = [
  {
    name: 'anexoLaudoSUS',
    label:
      'Cópia autenticada do laudo emitido por órgão oficial (SUS/INSS) em papel timbrado* OU Formulário de Informações Complementares*',
  },
];

export const parents = [
  {
    name: 'anexoCertidaoCasamentoOuNascimento',
    label: 'Certidão de casamento/nascimento do falecido*',
  },
];

export const parentsParticipant = [
  {
    name: 'anexoCertidaoCasamentoOuNascimentoParticipante',
    label: 'Certidão de casamento/nascimento do Participante*',
  },
];

export const concessionLetterINSS = [
  {
    name: 'anexoCartaConcessaoINSS',
    label: 'Carta de concessão do INSS (se titular faleceu em atividade)',
  },
];

export const spouses = [
  { name: 'anexoCertidaoCasamento', label: 'Certidão de casamento*' },
];

export const declarationTaxConjuntIR = [
  {
    name: 'declarationTaxConjuntIR',
    label: 'Declaração conjunta de imposto de renda*',
  },
];

export const childs = [
  { name: 'anexoCertidaoNascimento', label: 'Certidão de nascimento*' },
];

export const studentUniversity = [
  {
    name: 'anexoComprovanteEscolaridade',
    label: 'Comprovante de escolaridade*',
  },
];

export const isencaoIR = [
  {
    name: 'anexoLaudoINSS',
    label:
      'Laudo emitido pelo INSS OU Formulário de Informações Médicas Complementares*',
  },
  { name: 'anexoLaudoMedicoIsencao', label: 'Laudo médico' },
];

export const specialChild = [
  {
    name: 'anexoLaudoMedico',
    label: 'Laudo médico que comprove a invalidez (perícia)*',
  },
];

export const menorTutela = [
  {
    name: 'anexoTermoTutelaJudicial',
    label: 'Termo de Tutela Judicial*',
  },
];

export const certidaoGenitor = [
  {
    name: 'anexoCertidaoCasamentoGenitor',
    label: 'Certidão de casamento entre o participante e genitor do enteado*',
  },
];

export const stepchild = [
  ...certidaoGenitor,
  {
    name: 'anexoDeclaracaoNaoEmancipacao',
    label: 'Declaração de não emancipação*',
  },
  {
    name: 'anexoDependeciaEconomica',
    label: 'Comprovação de dependência econômica do enteado*',
  },
  {
    name: 'anexoIRSegurado',
    label:
      'Declaração do imposto de renda do segurado, em que conste o interessado como seu dependente*',
  },
  { name: 'anexoTestamentarias', label: 'Disposições testamentárias' },
  {
    name: 'anexoProvaVidaCivil',
    label:
      'Prova de encargos domésticos evidentes e existência de sociedade ou comunhão nos atos da vida civil*',
  },
  {
    name: 'anexoProcuracao',
    label: 'Procuração ou fiança reciprocamente outorgada;',
  },
  {
    name: 'anexoAnotacaoFicha',
    label: 'Anotação constante de ficha ou Livro de Registro de empregados*',
  },
  {
    name: 'anexoFichaTratamentoMedico',
    label:
      'Ficha de tratamento em instituição de assistência médica da qual conste o segurado como responsável;',
  },
  {
    name: 'anexoEscrituraImovel',
    label:
      'Escritura de compra e venda de imóvel pelo segurado em nome do dependente*',
  },
  {
    name: 'anexoQuaisquerOutros',
    label:
      'Quaisquer outros documentos que possam levar à convicção do fato a comprovar*',
  },
];

export const termoMAI = [
  { name: 'anexoTermoMAI', label: 'Termo de Opcao Forma de Pagamento MAI' },
];

export const provaDomicilio = [
  { name: 'anexoProvaDomicilio', label: 'Prova de mesmo domicílio*' },
];

export const commonsOtherDocs = [
  { name: 'anexoSB40', label: 'SB40*' },
  { name: 'anexoDIRBEN', label: 'DIRBEN*' },
  { name: 'anexoPPP', label: 'PPP*' },
];

export const concession = [
  {
    name: 'anexoCienciaConcessao',
    label: 'Termo de ciência e compromisso para concessão de benefício*',
  },
];

export const decision = [
  { name: 'anexoDecisao', label: 'Comunicação de Decisão' },
];

export const otherDocs = [
  ...decision,
  {
    name: 'anexoCTPS',
    label: 'CTPS (página identificação e contratos)* OU CNIS*',
  },
  {
    name: 'anexoCertReservista',
    label: 'Certificado de reservista OU Carnê de contribuição autônoma',
  },
];

export const otherDocs2 = [
  { name: 'anexoDecisao', label: 'Comunicação de Decisão' },
  {
    name: 'anexoCTPS',
    label: 'CTPS (página identificação e contratos)* OU CNIS*',
  },
  {
    name: 'anexoCertReservista',
    label: 'Certificado de reservista OU Carnê de contribuição autônoma',
  },
];

export const otherDocs3 = [
  {
    name: 'anexoCTPS',
    label: 'CTPS (página identificação e contratos)* OU CNIS*',
  },
  {
    name: 'anexoCertReservista',
    label: 'Certificado de reservista OU Carnê de contribuição autônoma',
  },
];

export const concessionLetter = [
  { name: 'anexoCarta', label: 'Carta de concessão e memória de cálculo' },
];

export const concessionLetterRequired = [
  { name: 'anexoCarta', label: 'Carta de concessão e memória de cálculo*' },
];

export const revisedConcessionLetter = [
  {
    name: 'anexoCartaRevisada',
    label: 'Carta de concessão e memória de cálculo revisada*',
  },
  {
    name: 'anexoCartaInicial',
    label: 'Carta de concessão e memória de cálculo inicial*',
  },
];

export const inheritorDocs = [
  {
    name: 'anexoHerdeiro',
    label:
      'Escritura Pública de Inventário e Partilha firmada em cartório *' +
      'OU Inventário judicial*',
  },
  {
    name: 'anexoDeclaracaoHerdeiros',
    label: 'Declaração de Únicos Herdeiros*',
  },
];

export const revisedDocsCommons = [
  {
    name: 'anexoSentecaJudicial',
    label: 'Sentença judicial*',
  },
  // {
  //   name: 'anexoDecisoesLiminares',
  //   label: 'Decisões de Liminares ou de Mérito do Processo*',
  // },
  {
    name: 'anexoMovimentacaoProcessualAtualizada',
    label: 'Movimentação Processual Atualizada*',
  },
];

export const convivente = [
  {
    name: 'anexoConvivente',
    label: (
      <ul>
        <p>Insira um ou mais arquivos das seguintes opções</p>
        <li>
          Declaração de Imposto de Renda do participante que conste o
          companheiro como dependente*
        </li>
        <li>Certidão de nascimento de filho havido em comum*</li>
        <li>Escritura pública atestando a união estável *</li>
        <li>
          Declaração escrita de união estável* (caso seja inserida esse
          documento, pelo menos um tipo de documento relacionado no bloco de
          anexos subsequente é obrigatório)
        </li>
      </ul>
    ),
  },
];

export const casoUniaoEstavel = [
  {
    name: 'anexoCasoUniaoEstavel',
    label: (
      <ul>
        <li>
          Anotação constante na Carteira Profissional e/ou na Carteira de
          Trabalho e Previdência Social - CTPS feita pelo Ministério do
          Trabalho, através da Delegacia Regional do Trabalho*
        </li>
        <li>
          Declaração especial feita perante tabelião (escritura pública
          declaratória de dependência econômica) *
        </li>
        <li>Contrato de união estável registrado em cartório*</li>
        <li>Certidão de casamento religioso*</li>
        <li>Prova de mesmo domicílio*</li>
        <li>
          Prova de encargos domésticos evidentes e existência de sociedade ou
          comunhão nos atos da vida civil, com convivência no mesmo domicílio*
        </li>
        <li>
          Registro em associação de qualquer natureza onde conste o
          companheiro(a) como dependente do Participante*
        </li>
        <li>
          Apólice de seguro da qual conste o Participante como instituidor do
          seguro e o(a) companheiro(a) como seu(sua) beneficiário(a) ou
          vice-versa*
        </li>
        <li>Conta bancária conjunta de pessoa física ativa*</li>
      </ul>
    ),
  },
];

export const casoUniaoEstavelIR = [
  {
    name: 'anexoCasoUniaoEstavel',
    label:
      'Declaração de união estável ou certidão de nascimento de filho havido em comum*',
  },
];

export const commonsOtherDocs2 = [
  {
    name: 'anexoSB40Etc',
    label: (
      <ul>
        <p>
          Inserir um ou mais dos itens abaixo(Caso tenha informado anexo de
          Comunicado de Decisão)
        </p>
        <li>SB40*</li>
        <li>DIRBEN*</li>
        <li>PPP*</li>
        <li>Resumo de contagem de tempo* (apenas caso não aposentado)</li>
      </ul>
    ),
  },
];

export const commonsOtherDocs3 = [
  {
    name: 'anexoSB40Etc',
    label: (
      <ul>
        <p>Inserir ou o Processo Administrativo ou SB40 e DIRBEN e PPP</p>
        <li>SB40*</li>
        <li>DIRBEN*</li>
        <li>PPP*</li>
        <li>Processo administrativo*</li>
      </ul>
    ),
  },
];

export const commonsOtherDocs4 = [
  {
    name: 'anexoSB40Etc',
    label: (
      <ul>
        <p>Inserir um ou mais dos itens abaixo</p>
        <li>SB40*</li>
        <li>DIRBEN*</li>
        <li>PPP*</li>
      </ul>
    ),
  },
];
